import { Customer } from "../domain/customer/Customer";

export const fireCustomerAddedEvent = (customer: Customer) => {
    const event = document.createEvent('Event') as any;
    event.data = customer;
    event.initEvent('customer_added', true, true);
    document.body.dispatchEvent(event);
}

export default fireCustomerAddedEvent;
